export const getDDDFromPhoneNumber = (phoneNumber: string): string =>
  String(phoneNumber).slice(0, 2);
